import { Link } from "react-router-dom";
import Button from "../../../../../../library/button";
import { Title } from "../../../../../../library/title";
import logoLight from "../../../../../../assets/img/logo-single.svg";
import {
  ButtonsWrapper,
  FullTitleWrapper,
  TitleWrapper,
  GoBackIcon,
  ReturnWrapper,
  TopBarWrapper,
  LastSavedLabel,
  Logo,
} from "./styled";
import Modal from "../../../../../../library/modal";
import { getIcon } from "../../../../../../utils/get-icon";
import ReactTimeAgo from "react-time-ago";
import useVideo from "../../../../../../hooks/useVideo";
import ExportDetails from "../../../../../../components/ExportModal";
import { useSettings } from "../../context";
import { useEffect, useState } from "react";
import DownloadModal from "../../download-modal";
import { sendErrorNotification } from "../../../../../../library/notification";

const DesktopTopBar = () => {
  const { generationProgress, isGenerating, generateVideo, videoDownloadUrl } =
    useSettings();
  const [showExportModal, setShowExportModal] = useState<boolean>(false);
  const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);

  const { video } = useVideo();

  const lastUpdated = video?.lastUpdated ?? 0;

  const clickDownload = async () => {
    try {
      await generateVideo();
    } catch (e) {
      sendErrorNotification("Kunne ikke laste ned video.");
    }
  };

  const closeExportModal = () => {
    setShowExportModal(false);
  };

  const openExportModal = () => {
    setShowExportModal(true);
  };

  const closeDownloadModal = () => {
    setShowDownloadModal(false);
  };

  const openDownloadModal = () => {
    setShowDownloadModal(true);
  };

  const renderDownloadButton = () => {
    if (isGenerating) {
      return `Genererer video (${generationProgress}%)`;
    } else {
      return "Last ned video";
    }
  };

  useEffect(() => {
    if (videoDownloadUrl) {
      openDownloadModal();
    }
  }, [videoDownloadUrl]);

  return (
    <>
      <TopBarWrapper>
        <ReturnWrapper>
          <Link to="/dashboard/transcripts">
            <GoBackIcon>{getIcon("editor-back")}</GoBackIcon>
            <Logo src={logoLight} />
          </Link>
          <FullTitleWrapper>
            <TitleWrapper>
              <Title size="xs">{video?.filename}</Title>
            </TitleWrapper>
            <LastSavedLabel>
              Sist lagret <ReactTimeAgo date={lastUpdated * 1000} />
            </LastSavedLabel>
          </FullTitleWrapper>
        </ReturnWrapper>
        <ButtonsWrapper>
          <Button
            onClick={openExportModal}
            variant="regular"
            size="md"
            color="grey"
            icon="transcription"
          >
            Eksporter
          </Button>
          <Button
            onClick={clickDownload}
            icon={isGenerating ? "spinner" : "download"}
            variant="regular"
            size="md"
            color="blue"
            spacing="left"
          >
            {renderDownloadButton()}
          </Button>
        </ButtonsWrapper>
      </TopBarWrapper>
      <Modal
        open={showExportModal}
        onClose={closeExportModal}
        title="Eksporter undertekster"
      >
        <ExportDetails
          onClose={closeExportModal}
          videoId={video.id}
          fileName={video.filename}
        />
      </Modal>
      <Modal
        open={showDownloadModal}
        onClose={closeDownloadModal}
        title="Videoen din er ferdig"
      >
        <DownloadModal
          downloadUrl={videoDownloadUrl}
          onClose={closeDownloadModal}
        />
      </Modal>
    </>
  );
};

export default DesktopTopBar;
